const routes = {
    getArtBoards:'/artboards',
    CreateArtBoard:'/artboards/add',
    DeleteArtBoard:'/artboards/delete',
    UpdateArtBoard:"/artboards/update"

  };
  
  export default routes